document.addEventListener("algolia.hooks.initialize", function () {
  algoliaShopify.hooks.registerHook("beforeInstantSearchAllowParamsArray", function (allowParamsArray) {
    // Modify default array, then return an array
    const whiteListedParams = [
      "ajs_aid",
      "fpc",
      "clientId",
      "utm_source",
      "utm_medium",
      "utm_campaign",
      "utm_term",
      "utm_content",
    ];
    return [allowParamsArray, ...whiteListedParams];
  });
});
